import React, { useContext, useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import FileDropBox from '../filedropbox/FileDropBox';
import ProjectContext from '../../contexts/ProjectContext';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useFetch } from '../../components/auth/useFetch';


export default function UploadExploreDialog(props) {

    const { anchorEl, filterClips, open, setOpen, updateParentList } = props
    const projectContext = useContext(ProjectContext);
    const fetchWithAuth = useFetch()
    const [file, setFile] = React.useState('')

    const handleClose = () => {
        setOpen(false);
        setFile(null);
    };
    const handleSubmit = () => {
        if (!file) return;
        setOpen(false);
        uploadEDL();
        setFile(null);
    };
    
    const uploadEDL = async () => {
        var formdata = new FormData();
        formdata.append("file_upload", file);
        var requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow',
            headers: {
                'X-Project-ID': projectContext?.project_db
            },
        }
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/edlclipnames/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                filterClips(result)
            })
            .catch(e => {
                console.error(e);
                setOpen(false)
            })
    }


    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        width: "auto",
                        height: "auto",
                        backgroundColor: "#282828",
                    },
                }}
            >
                <DialogTitle>Filter by EDL</DialogTitle>
                <DialogContent>
                    <FileDropBox
                        titleText="Drop EDL files here or click to select"
                        UploadIcon={<CloudUploadIcon sx={{ fontSize: 48, opacity: 0.4 }} />} // Replace with an actual icon if needed
                        setFile={setFile} />
                    {file && (
                        <Box
                            sx={{
                            mt: 2,
                            p: 1,
                            backgroundColor: "#222",
                            color: "white",
                            borderRadius: "4px",
                            fontSize: "0.95rem",
                            wordBreak: "break-all"
                            }}
                        >
                            {file.name}
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} sx={{ color: 'white' }}>
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} sx={{ color: 'white' }}>
                        Upload
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )}